const LONG_DASH = "—";

export const stringFallback = (value: string | undefined | null): string => {
  return typeof value === "string" && value !== "" ? value : LONG_DASH;
};

export const numberFallback = (value: number | undefined | null): number => {
  return typeof value === "number" ? value : 0;
};

export const nodeFallback = (
  value: React.ReactNode | undefined | null
): NonNullable<React.ReactNode> => {
  if (!value) return LONG_DASH;
  return stringFallback(value?.toString()) === LONG_DASH ? LONG_DASH : value;
};
